import { render } from "./FormCancelButton.vue?vue&type=template&id=65607b2c"
import script from "./FormCancelButton.vue?vue&type=script&lang=js"
export * from "./FormCancelButton.vue?vue&type=script&lang=js"

import exportComponent from "/home/omid_es327/Projects/erp/laravel/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"FormCancelButton.vue"]])

export default __exports__